import SupportChat from '@persona-id/support-chat';
import { History } from 'history';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { printMixins } from 'dashboard/lib/printMixins';
import { Z_INDICES } from 'dashboard/styles/variables';
import useIsPersonerd from 'lib/hooks/useIsPersonerd';
import { captureException, captureMessage } from 'lib/reporting';

export { openSupportChat } from '@persona-id/support-chat';

export interface SupportChatHelperProps {
  pageContentEnabled: boolean;
  isLoggedIn: boolean;
  customReportBugCallback: () => void | undefined;
  isActiveOrganization: boolean;
}

export default function SupportChatHelper({
  pageContentEnabled,
  isLoggedIn,
  customReportBugCallback,
  isActiveOrganization,
}: SupportChatHelperProps) {
  const isPersonerd = useIsPersonerd();
  const history: History = useHistory();

  const pageContentConfigs = [
    {
      name: 'Case' as const,
      type: 'iframe' as const,
      pathnamePattern: `^/dashboard/cases/case_.*`,
      introMessage:
        'You can ask about anything covered in Help Center, Developer Docs, withpersona.com, or the current Case. Want to try asking a question?',
      suggestions: [
        'Summarize the Case for me',
        'Highlight what I should look into first',
        'Tell me about the failed Verifications',
      ],
      loadingSelector: `[class^="LoadingIndicator"]`,
      readableIdSelector: `[class*="CaseInfo__TitleContainer"]`,
      applicationRootNode: '#main-application',
      retryIntervalMs: 1000,
      retryTimeoutMs: 60000,
      computeIframePathname: (pathname: string) => {
        const parts = pathname.split('/');
        const casesIndex = parts.findIndex((part) => part === 'cases');

        return [...parts.slice(0, casesIndex + 2), 'print'].join('/');
      },
    },
  ];

  return (
    <div data-test='support-chat-wrapper'>
      {isLoggedIn && (
        <SupportChatContainer data-test='support-chat'>
          <SupportChat
            pageContent={{
              enabled: pageContentEnabled,
              configs: pageContentConfigs,
            }}
            history={history}
            captureMessage={captureMessage}
            captureException={captureException}
            shouldOverrideCloudFunctionDomain={import.meta.env.DEV}
            {...{ isActiveOrganization, ...(isPersonerd ? { customReportBugCallback } : {}) }}
          />
        </SupportChatContainer>
      )}
    </div>
  );
}

const SupportChatContainer = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: ${Z_INDICES.supportChat};
  pointer-events: none;

  ${printMixins.hide}
`;
